"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.SecondPicture = exports.Row = exports.RightsReserved = exports.LinksContainer = exports.Links = exports.LinkItem = exports.Language = exports.IconStyled = exports.Icons = exports.FirstPicture = exports.Copyright = exports.Container = exports.Column = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _Icon = _interopRequireDefault(require("../../atoms/Icon"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;

var Column = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: center;\n  margin-bottom: 30px;\n"])));

exports.Column = Column;
Column.displayName = 'Column';

var Container = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  border-top: 1px solid ", ";\n  display: flex;\n  flex-direction: column;\n  padding-top: 50px;\n"])), _palette.palette.secondary);

exports.Container = Container;
Container.displayName = 'Container';

var Copyright = _styledComponents["default"].p(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-size: 14px;\n  line-height: 1.43;\n  margin-bottom: 0;\n"])), _palette.palette.grey);

exports.Copyright = Copyright;
Copyright.displayName = 'Copyright';

var FirstPicture = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  flex: 1;\n  margin-top: 55px;\n  text-align: center;\n  ", " {\n    text-align: inherit;\n  }\n"])), _widths.mediaQueries.desktop);

exports.FirstPicture = FirstPicture;
FirstPicture.displayName = 'FirstPicture';

var Icons = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display       : flex;\n  flex-direction: row;\n"])));

exports.Icons = Icons;
var IconStyled = (0, _styledComponents["default"])(_Icon["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: pointer;\n  display: inline;\n  margin-right: 20px;\n"])));
exports.IconStyled = IconStyled;
IconStyled.displayName = 'IconStyled';

var Language = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-size: 14px;\n  font-weight: ", ";\n  line-height: 2.14;\n  margin-bottom: 10px;\n  &:hover {\n    cursor: pointer;\n  }\n"])), _palette.palette.secondary, _widths.font.semi);

exports.Language = Language;
Language.displayName = 'Language';

var LinkItem = _styledComponents["default"].a(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: ", ";\n  line-height: 2.14;\n  margin: 0;\n"])), _palette.palette.grey, _widths.font.semi);

exports.LinkItem = LinkItem;
LinkItem.displayName = 'LinkItem';

var Links = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  flex-direction: column;\n  min-width: 160px;\n  padding-left: 30px;\n  display: flex;\n  ", " {\n    min-width: 200px;\n    padding-left: 0;\n  }\n"])), _widths.mediaQueries.desktop);

exports.Links = Links;
Links.displayName = 'Links';

var LinksContainer = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n\n  ", " {\n    flex-direction: row;\n  }\n"])), _widths.mediaQueries.desktop);

exports.LinksContainer = LinksContainer;
LinksContainer.displayName = 'LinksContainer';

var RightsReserved = _styledComponents["default"].p(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-size: 14px;\n  line-height: 1.43;\n  margin: 0;\n"])), _palette.palette.lightGrey);

exports.RightsReserved = RightsReserved;
RightsReserved.displayName = 'RightsReserved';

var Row = _styledComponents["default"].div(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: center;\n"])));

exports.Row = Row;
Row.displayName = 'Row';

var SecondPicture = _styledComponents["default"].div(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: 40px;\n  display: none;\n  & img {\n    width: 100%;\n  }\n  ", " {\n    display: block;\n  }\n"])), _widths.mediaQueries.desktop);

exports.SecondPicture = SecondPicture;
SecondPicture.displayName = 'SecondPicture';

var Title = _styledComponents["default"].h3(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  font-size: 14px;\n  line-height: 2.14;\n  margin: 0;\n"])), _palette.palette.lightGrey);

exports.Title = Title;
Title.displayName = 'Title';